import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, AppDispatch } from '../reduxStore/store';
import { fetchEarnPointsRules, redeemPoints } from '../models/earnPointsSlice';
import EarnPointsItem from './item';
import Header from '../shared/header';
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import LoadingIndicator from '../shared/loadingIndicator';
import { useSettings } from '../../hooks/useSettings';

const EarnPointsScreen: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { earnPointsRules, isLoading, error } = useSelector((state: RootState) => state.earnPoints);
 const { settings, getSetting } = useSettings();
  const site_loyalty_page_url = getSetting('site_loyalty_page_url');
  
  useEffect(() => {
    dispatch(fetchEarnPointsRules());
  }, [dispatch]);

  const handleItemTap = async (type: string, url?: string) => {
    const result = await dispatch(redeemPoints(type));
    if (redeemPoints.fulfilled.match(result)) {
      if (type === 'complete_profile_points') {
        window.location.href = '/account';
      } else if (type === 'birthday_point_value') {
        // Handle birthday points
      } else if (type === 'newsletter_points') {
        window.parent.postMessage({ action: 'redirectearnpoints', url: url }, '*');
      } else if (url) {
        window.parent.postMessage({ action: 'redirectearnpoints', url: url }, '*');
      }
    } else if (redeemPoints.rejected.match(result)) {
      alert(result.payload as string);
    }
  };

  const getPointsData = (type: string) => {
    return earnPointsRules[type] || { redeemed: false, points: '0' };
  };

  // Helper component to conditionally render items
  const ConditionalEarnPointsItem = ({ type, ...props }: any) => {
    if (!earnPointsRules.hasOwnProperty(type)) {
      return null;
    }
    
    const pointsData = getPointsData(type);
    return (
      <EarnPointsItem
        {...props}
        points={`${pointsData.points} Pt`}
        isRedeemed={pointsData.redeemed}
        url={pointsData.url}
        onTap={(url: string) => handleItemTap(type, url)}
      />
    );
  };

  if (isLoading && Object.keys(earnPointsRules).length === 0) {
    return (
      <div className="flex justify-center items-center h-52">
        <LoadingIndicator />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      {/* App Bar */}
      <div className="fixed top-0 z-10">
        <a href="/homePage">
          <Header icon={<KeyboardArrowLeftIcon />} name="Earn Points" />
        </a>
      </div>

      {/* Content */}
      <div className="px-4 py-2 pb-10 mt-12">
        <div className="bg-white rounded-t-2xl">
          {/* Facebook Like/Follow */}
          <ConditionalEarnPointsItem
            icon="facebook"
            title="Like on"
            subtitle="Facebook"
            type="facebook_like_points"
          />

          {/* Instagram Follow */}
          <ConditionalEarnPointsItem
            icon="instagram"
            title="Follow on"
            subtitle="Instagram"
            type="instagram_follow_points"
          />

          {/* TikTok Like */}
          <ConditionalEarnPointsItem
            icon="tiktok"
            title="Like on"
            subtitle="TikTok"
            type="tiktok_like_points"
          />

          {/* LinkedIn Follow */}
          <ConditionalEarnPointsItem
            icon="linkedin"
            title="Follow on"
            subtitle="LinkedIn"
            type="linkedin_follow_points"
          />

          {/* X (Twitter) Follow */}
          <ConditionalEarnPointsItem
            icon="x-twitter"
            title="Follow on"
            subtitle="X (Twitter)"
            type="x_follow_points"
          />

          {/* YouTube Subscribe */}
          <ConditionalEarnPointsItem
            icon="youtube"
            title="Subscribe on"
            subtitle="YouTube"
            type="youtube_subscribe_points"
          />

          {/* Newsletter */}
          <ConditionalEarnPointsItem
            icon="envelope"
            title="Subscribe to"
            subtitle="Newsletter"
            type="newsletter_points"
          />

          {/* Birthday */}
          <ConditionalEarnPointsItem
            icon="gift"
            title="Claim Your"
            subtitle="Birthday Points"
            type="birthday_point_value"
          />

          {/* Complete Profile */}
          <ConditionalEarnPointsItem
            icon="user"
            title="Complete your"
            subtitle="Profile"
            type="complete_profile_points"
          />
        </div>
      </div>
    </div>
  );
};

export default EarnPointsScreen;